const cf7Config = window.juniperContactForm || {};
const TOPICS_REQUIRING_PRODUCT = cf7Config.topicsRequiringProduct || [];

function initTopicProductConditional(form) {
  const topicSelect = form.querySelector('[name="topic"]');
  const productWrap = form.querySelector(
    '.wpcf7-form-control-wrap[data-name="product"]',
  );

  if (!topicSelect || !productWrap) return;

  const productField = productWrap.closest('label') || productWrap;
  const productSelect = productWrap.querySelector('select[name="product"]');

  function sync() {
    const shouldShow = TOPICS_REQUIRING_PRODUCT.includes(topicSelect.value);

    productField.hidden = !shouldShow;

    if (!productSelect) return;

    productSelect.toggleAttribute('required', shouldShow);
    productSelect.setAttribute('aria-required', String(shouldShow));

    if (!shouldShow && productSelect.value) {
      productSelect.value = '';
      productSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  topicSelect.addEventListener('change', sync);

  form.addEventListener('reset', () => {
    setTimeout(sync, 0);
  });

  sync();
}

function initContactFormConditionals() {
  document.querySelectorAll('.wpcf7 form').forEach(initTopicProductConditional);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initContactFormConditionals);
} else {
  initContactFormConditionals();
}
